import React, {FC} from 'react';
import styled from 'styled-components';

import {directHoverSelector} from '../../../../libs/shared/helpers/src/browser/hoverHelpers';
import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

export interface EmailComposerMoreProps {
  isCcVisible: boolean;
  isBccVisible: boolean;
  isSubjectVisible: boolean;
  canPopout: boolean;
  showCc: Handler;
  showBcc: Handler;
  showSubject: Handler;
  popout: Handler;
}

/*
 * Style.
 */

interface WrapperStyleProps {
  $canPopout?: boolean;
}
const StyledWrapperDiv = styled.div<WrapperStyleProps>`
  grid-area: more;
  margin-left: 18px;
  margin-right: ${(p) => (p.$canPopout ? '18px' : '21px')};
  margin-top: ${(p) => (p.$canPopout ? '22px' : '27px')};

  display: grid;
  grid-gap: 7px;
  grid-auto-flow: column;
  align-items: center;
`;

const StyledMoreButton = styled(ChromelessButton)`
  padding: 3px 4px;

  border-radius: 4px;
  color: ${(p) => p.theme.greys.shade80};
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.verySmall};

  ${directHoverSelector} {
    background-color: ${(p) => p.theme.alphas.gray10};
    color: ${(p) => p.theme.greys.shade80};
  }
`;

/*
 * Component.
 */

export const EmailComposerMore: FC<EmailComposerMoreProps> = (props) => {
  const theme = useUserTheme();
  const {isCcVisible, isBccVisible, isSubjectVisible, canPopout} = props;
  const noneAreVisible = isCcVisible && isBccVisible && isSubjectVisible && !canPopout;

  if (noneAreVisible) {
    return null;
  }

  return (
    <StyledWrapperDiv $canPopout={canPopout}>
      {!isCcVisible && (
        <StyledMoreButton onClick={props.showCc} onDragEnter={props.showCc}>
          <Trans id="composer-actions-cc">Cc</Trans>
        </StyledMoreButton>
      )}
      {!isBccVisible && (
        <StyledMoreButton onClick={props.showBcc} onDragEnter={props.showBcc}>
          <Trans id="composer-actions-bcc">Bcc</Trans>
        </StyledMoreButton>
      )}
      {!isSubjectVisible && (
        <StyledMoreButton onClick={props.showSubject}>
          <Trans id="composer-actions-subject">Subject</Trans>
        </StyledMoreButton>
      )}
      {canPopout && (
        <IconButton
          iconName="popoutSmall"
          label={<Trans id="composer-actions-popout">Popout</Trans>}
          onClick={props.popout}
          color={theme.greys.shade80}
        />
      )}
    </StyledWrapperDiv>
  );
};
